import { format, formatDistanceToNowStrict, parseISO } from "date-fns";

export const CATEGORY_STYLES = {
  "Advance Payment": {
    badge: "border-catadvance-border bg-catadvance-surface text-catadvance-text",
    dot: "bg-catadvance-dot",
  },
  "Needs Attention": {
    badge: "border-catneeds-border bg-catneeds-surface text-catneeds-text",
    dot: "bg-catneeds-dot",
  },
  "Approval Replies": {
    badge: "border-catapproval-border bg-catapproval-surface text-catapproval-text",
    dot: "bg-catapproval-dot",
  },
  Other: {
    badge: "border-catother-border bg-catother-surface text-catother-text",
    dot: "bg-catother-dot",
  },
};

export const STATUS_STYLES = {
  ready: { label: "Ready", cls: "border-qready-border bg-qready-surface text-qready-text" },
  needs_review: {
    label: "Needs Review",
    cls: "border-qreview-border bg-qreview-surface text-qreview-text",
  },
  exported: {
    label: "Exported",
    cls: "border-qexported-border bg-qexported-surface text-qexported-text",
  },
};

export function safeDate(iso) {
  if (!iso) return null;
  try {
    const d = typeof iso === "string" ? parseISO(iso) : new Date(iso);
    return isNaN(d.getTime()) ? null : d;
  } catch (e) {
    return null;
  }
}

export function relTime(iso) {
  const d = safeDate(iso);
  if (!d) return "";
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "just now";
  try {
    return `${formatDistanceToNowStrict(d)} ago`;
  } catch (e) {
    return "";
  }
}

export function absTime(iso) {
  const d = safeDate(iso);
  if (!d) return "";
  try {
    return format(d, "dd MMM yyyy, HH:mm");
  } catch (e) {
    return "";
  }
}

export function shortDate(iso) {
  const d = safeDate(iso);
  if (!d) return "";
  try {
    return format(d, "dd MMM");
  } catch (e) {
    return "";
  }
}

export function inr(value) {
  if (value === null || value === undefined || value === "") return "";
  const n = typeof value === "number" ? value : Number(String(value).replace(/[^\d.]/g, ""));
  if (!isFinite(n) || n === 0) return "";
  return n.toLocaleString("en-IN", { maximumFractionDigits: 2 });
}

export function prettyBytes(b) {
  const n = Number(b || 0);
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}

export function initials(nameOrEmail = "") {
  const s = String(nameOrEmail || "").trim();
  if (!s) return "?";
  const parts = s
    .replace(/[<>]/g, " ")
    .split(/[\s@._-]+/)
    .filter(Boolean);
  return ((parts[0]?.[0] || "") + (parts[1]?.[0] || "")).toUpperCase() || s[0].toUpperCase();
}
